/* js-custom-all.js */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);

    var partner = (params.get("partner") || "").toLowerCase();
    if (!partner) return;

    var path = window.location.pathname.replace(/\/$/, "") || "/";

    // ==== Partner config (thêm/sửa ở đây) ====
    var partnerConfig = {
      his_okaden2026: {
        allowedPaths: ["/", "/en", "/collections/*"],

        label: "エイチアイエスのお客様　専用ページ",
        title: "岡田電気産業株式会社様専用ページ",
        message: "岡田電気産業株式会社様限定<br>特別5%OFFでeSIMが購入できるページです。 ",
        logo:
          "https://cdn.shopify.com/s/files/1/0809/3686/2008/files/his-logo-4431.jpg?v=1773129502",
        color: "#0119b7",
        // note: "※専用リンクからアクセスした場合のみ表示されます。",
      },

      jtb_testt: {
        allowedPaths: ["/", "/special", "/campaign/*"],

        label: "JTBのお客様　専用ページ",
        title: "〇〇旅行の皆様",
        message: "このページは、お客様限定の特別5％OFFページです。",
        logo:
          "https://cdn.shopify.com/s/files/1/0809/3686/2008/files/messageImage_1775012558322.jpg?v=1775012838",
        color: "#C71529",
        // note: "※専用リンクからアクセスした場合のみ表示されます。",
      },
    };

    var cfg = partnerConfig[partner];
    if (!cfg) return;

    // ==== check allowed path ====
    var isAllowed = (cfg.allowedPaths || []).some(function (p) {
      // wildcard support
      if (p.endsWith("/*")) {
        var base = p.replace("/*", "");
        return path.startsWith(base);
      }

      // exact match
      return path === p;
    });

    if (!isAllowed) return;

    // show once / session / partner
    var key = "partner_modal_seen_" + partner;

    if (sessionStorage.getItem(key)) return;

    sessionStorage.setItem(key, "1");

    // inject styles once
    if (!document.getElementById("partner-modal-style")) {
      var style = document.createElement("style");

      style.id = "partner-modal-style";

      style.textContent = `
        .pm-overlay{
          position:fixed; inset:0; z-index:99999;
          background: rgba(15, 23, 42, .55);
          display:flex; align-items:center; justify-content:center;
          padding: 18px;
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          animation: pmFadeIn .16s ease-out both;
        }

        @keyframes pmFadeIn{
          from{opacity:0}
          to{opacity:1}
        }

        .pm-card{
          width: min(560px, 100%);
          background:#fff;
          border-radius: 10px;
          box-shadow: 0 24px 60px rgba(0,0,0,.28);
          overflow:hidden;
          transform: translateY(10px) scale(.985);
          animation: pmPop .18s ease-out both;
          font-family: system-ui, -apple-system, Segoe UI, Roboto, "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
        }

        @keyframes pmPop{
          to{ transform: translateY(0) scale(1) }
        }

        .pm-head{
          padding: 16px 18px 12px;
          border-bottom: 1px solid rgba(15,23,42,.08);
          display:flex;
          align-items:flex-start;
          justify-content:space-between;
          gap: 12px;
        }

        .pm-left{
          display:flex;
          gap: 12px;
          align-items:center;
          min-width:0;
        }

        .pm-logo{
          max-width: 100px;
          height: 38px;
          border-radius: 12px;
          background: rgba(15,23,42,.06);
          display:flex;
          align-items:center;
          justify-content:center;
          flex: 0 0 auto;
          overflow:hidden;
        }

        .pm-logo img{
          width:100%;
          height:100%;
          object-fit:cover;
          display:block;
        }

        .pm-badge{
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding: 6px 10px;
          border-radius: 999px;
          background: rgba(17,24,39,.06);
          color: rgba(17,24,39,.85);
          font-size: 12px;
          font-weight: 700;
          white-space: nowrap;
        }

        .pm-title{
          margin-top: 10px;
          font-size: 2rem;
          font-weight: 800;
          line-height: 1.35;
          color: #0f172a;
          overflow:hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 420px;
        }

        .pm-close{
          border:0;
          background: transparent;
          cursor:pointer;
          width: 36px;
          height: 36px;
          border-radius: 10px;
          display:flex;
          align-items:center;
          justify-content:center;
          color: rgba(15,23,42,.65);
          transition: background .12s ease, transform .12s ease;
          flex: 0 0 auto;
        }

        .pm-close:hover{
          background: rgba(15,23,42,.06);
        }

        .pm-close:active{
          transform: scale(.98);
        }

        .pm-body{
          padding: 30px 18px 30px;
        }

        .pm-msg{
          font-size: 1.6rem;
          line-height: 1.7;
          color: rgba(15,23,42,.86);
          text-align: center;
        }

        .pm-note{
          margin-top: 10px;
          font-size: 12px;
          line-height: 1.6;
          color: rgba(15,23,42,.55);
        }

        .pm-actions{
          padding: 0 18px 18px;
          display:flex;
          justify-content:center;
          gap: 10px;
        }

        .pm-btn{
          border: 1px solid rgba(15,23,42,.14);
          background: #fff;
          color: #0f172a;
          border-radius: 12px;
          padding: 10px 14px;
          font-weight: 800;
          cursor:pointer;
          transition: transform .12s ease, background .12s ease, border-color .12s ease;
          width: stretch;
        }

        .pm-btn:hover{
          background: rgba(15,23,42,.04);
          border-color: rgba(15,23,42,.18);
        }

        .pm-btn:active{
          transform: translateY(1px);
        }

        .pm-primary{
          border: 0;
          background: #0f172a;
          color: #fff;
          padding: 10px 16px;
        }

        .pm-primary:hover{
          background: #0b1220;
        }

        @media (max-width: 420px){
          .pm-title{
            white-space: normal;
            max-width: unset;
          }
        }
      `;

      document.head.appendChild(style);
    }

    // create modal
    var overlay = document.createElement("div");

    overlay.className = "pm-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Partner notice");

    var card = document.createElement("div");

    card.className = "pm-card";

    var logoHtml = cfg.logo
      ? '<div class="pm-logo"><img alt="" src="' + esc(cfg.logo) + '"/></div>'
      : '<div class="pm-logo" aria-hidden="true">🏷️</div>';

    card.innerHTML =
      '<div class="pm-head">' +
      '<div class="pm-left">' +
      logoHtml +
      '<div style="min-width:0;">' +
      '<div class="pm-badge" style="background:' +
      (cfg.bgColor || "#f3f4f6") +
      "; color:" +
      (cfg.color || "#111") +
      '">' +
      esc(cfg.label || partner.toUpperCase()) +
      "</div>" +
      '<div class="pm-title">' +
      esc(cfg.title || "専用ページ") +
      "</div>" +
      "</div>" +
      "</div>" +
      '<button class="pm-close" type="button" aria-label="Close">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      "</svg>" +
      "</button>" +
      "</div>" +
      '<div class="pm-body">' +
      '<div class="pm-msg">' + (cfg.message || "") + "</div>" +
      (cfg.note
        ? '<div class="pm-note">' + esc(cfg.note) + "</div>"
        : "") +
      "</div>" +
      '<div class="pm-actions">' +
      '<button class="pm-btn" type="button">閉じる</button>' +
      '<button class="pm-btn pm-primary" style="background:' +
      (cfg.color || "#0f172a") +
      '" type="button">OK</button>' +
      "</div>";

    overlay.appendChild(card);

    document.body.appendChild(overlay);

    // close handlers
    function close() {
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }

      document.removeEventListener("keydown", onKeydown);
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        close();
      }
    }

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        close();
      }
    });

    overlay.querySelector(".pm-close").addEventListener("click", close);

    var btns = overlay.querySelectorAll(".pm-actions .pm-btn");

    btns[0].addEventListener("click", close);
    btns[1].addEventListener("click", close);

    document.addEventListener("keydown", onKeydown);

    // focus first button
    setTimeout(function () {
      try {
        btns[1].focus();
      } catch (e) {}
    }, 0);

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (m) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        }[m];
      });
    }
  } catch (e) {
    // silent
  }
})();